import { useEffect, useRef } from 'react';

// Poll visible operational views; do not remount pages or discard open forms.
// Fallback for dropped events and writes made outside the API process.
export default function useAutoRefresh(refresh, enabled = true) {
  const latest = useRef(refresh);
  latest.current = refresh;
  useEffect(() => {
    if (!enabled) return;
    let busy = false;
    const run = async () => {
      if (document.hidden || busy) return;
      busy = true;
      try { await latest.current(); } finally { busy = false; }
    };
    const timer = setInterval(run, 15000);
    window.addEventListener('focus', run);
    window.addEventListener('online', run);
    window.addEventListener('dashboard:data-changed', run);
    return () => {
      clearInterval(timer);
      window.removeEventListener('focus', run);
      window.removeEventListener('online', run);
      window.removeEventListener('dashboard:data-changed', run);
    };
  }, [enabled]);
}
